<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path d="M9.5776 11C9.5776 12.6569 8.38651 14 6.91722 14C5.44793 14 4.25684 12.6569 4.25684 11" stroke="black" stroke-width="1.5"/>
    <path d="M5.87988 0.771484L7.83398 0.782227C9.62206 0.791847 11.0664 2.24413 11.0664 4.03223V7.68848C11.0665 8.34397 11.2389 8.98827 11.5654 9.55664L12.5381 11.25H1.24609L2.1748 9.49902C2.46178 8.95787 2.6123 8.35472 2.6123 7.74219V4.02148C2.61236 2.21977 4.07818 0.76179 5.87988 0.771484Z" stroke="black" stroke-width="1.5"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconAlert'
}
</script>
